export const getShouldForwardProp = shouldForwardPropArr => ({
  shouldForwardProp: prop => {
    return !shouldForwardPropArr.includes(prop);
  },
});
